import { BANNER } from '../../utils/constants';
import requestService from '../../services/request';
export default {
  state: {
    loading: false,
    error: false,
    banners: [],
    lastEnterpriseParams: null
  },
  getters: {
    [BANNER.GET_BANNERS]: state => state.banners,
    [BANNER.GET_BANNER_LOADING]: state => state.loading
  },
  mutations: {
    [BANNER.SET_BANNERS]: (state, payload) => {
      state.banners = payload;
    }
  },
  actions: {
    [BANNER.FETCH_BANNERS]: async ({ state, commit }, { enterpriseParams }) => {
      try {
        if (state.loading) return;
        const enterpriseParamsString = JSON.stringify(enterpriseParams);
        if (
          state.lastEnterpriseParams !== enterpriseParamsString ||
          !!state.error
        ) {
          state.lastEnterpriseParams = enterpriseParamsString;
          state.error = false;
          state.loading = true;
          const url = `${process.env.GET_BY_ENTERPRISE}/banner`;
          const result = await requestService(url, 'GET', {
            params: {
              ...enterpriseParams,
              desiredFields: {
                active: 0,
                deleted: 0,
                groups: 0,
                products: 0,
                validFrom: 0,
                validTo: 0,
                createdAt: 0,
                lastModified: 0,
                itemGroups: 0
              }
            },
            localErrorHandling: true
          });
          commit(BANNER.SET_BANNERS, result);
        }
      } catch (err) {
        console.error(err);
        state.error = true;
      } finally {
        state.loading = false;
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/banners.js